import { render, staticRenderFns } from "./GamePlayHeader.vue?vue&type=template&id=3cbc5c68&scoped=true"
import script from "./GamePlayHeader.vue?vue&type=script&lang=js"
export * from "./GamePlayHeader.vue?vue&type=script&lang=js"
import style0 from "./GamePlayHeader.vue?vue&type=style&index=0&id=3cbc5c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbc5c68",
  null
  
)

export default component.exports